import { ANALYTICS_SOURCES } from '@/js/constants/analytics';

/**
 * Откуда пришёл пользователь: сайт или Telegram Mini App
 * Нужен, чтобы в Метрике сравнивать конверсию онбординга по каналам
 * Сейчас всегда `web`. Когда появится мини-апп, определять канал здесь
 * и возвращать `ANALYTICS_SOURCES.TELEGRAM_MINIAPP`.
 */
export const resolveAnalyticsSource = () => ANALYTICS_SOURCES.WEB;
